import React from 'react';
import { Box } from '@mui/material';
import StaticInfographic from './StaticInfographic';

/**
 * A component that displays infographics for fall prevention modules
 * @param {Object} props - Component props
 * @param {String} props.module - The module name (e.g., "UnderstandingFallRisks")
 * @param {String} props.topic - The specific topic for the infographic
 * @returns {JSX.Element} - The rendered component
 */
const DynamicInfographic = ({ module, topic }) => {
  return (
    <Box>
      <StaticInfographic module={module} />
    </Box>
  );
};

export default DynamicInfographic;
